import { GeneratorParams, COLUMN_ID, COLUMN_TYPE, NUMBER_COLUMN_ID } from ".";
import { Column } from "../../types";

export default function generate({ statuses }: GeneratorParams): Column[] {
    const labels: { [labelId: string]: string } = {};
    const labels_positions_v2: { [labelId: string]: number } = {};

    for (const i in statuses) {
        const labelId = `${i}`;
        labels[labelId] = statuses[i];
        labels_positions_v2[labelId] = i as any;
    }

    return [
        {
            id: COLUMN_ID,
            type: COLUMN_TYPE,
            title: "Status",
            settings_str: JSON.stringify({
                done_colors: [1],
                sumType: "allStatuses",
                // todo
                color_mapping: { "2": 19, "19": 2 },
                labels_colors: {},
                labels,
                labels_positions_v2
            })
        },
        {
            id: NUMBER_COLUMN_ID,
            type: "numbers",
            title: "Weight",
            settings_str: JSON.stringify({})
        },
    ];
}
